module.exports = __webpack_public_path__ + "img/106.af22fdb5.jpg";